import React from 'react';

import { AppleButton } from './apple-button';
import { GoogleButton } from './google-button';
import * as Styled from './third-party-signup-buttons.style';

export type ThirdPartySignupButtonsProps = {
  isLoading?: boolean;
  onAppleLogin: () => void;
  onGoogleLogin: () => void;
};

export const ThirdPartySignupButtons: React.FC<
  ThirdPartySignupButtonsProps
> = ({ isLoading, onAppleLogin, onGoogleLogin }) => {
  return (
    <Styled.List>
      <Styled.ListItem>
        <AppleButton isLoading={isLoading} onClick={onAppleLogin} />
      </Styled.ListItem>
      <Styled.ListItem>
        <GoogleButton isLoading={isLoading} onClick={onGoogleLogin} />
      </Styled.ListItem>
    </Styled.List>
  );
};
